<!--
 * @Author: your name
 * @Date: 2021-06-21 18:35:54
 * @最后修改时间: 2022-02-07 10:25:40
 * @最后编辑: Betway
 * @Description: In User Settings Edit
 * @FilePath: \mrc-base-frontend\src\views\directory_management\module\tricode_parent.vue
-->
<template>
  <div>
    <v-menu
      v-model="showMenu"
      offset-y
      :readonly="readonly"
      nudge-top="20"
      :close-on-content-click="false"
      style="max-width: 600px"
    >
      <template v-slot:activator="{ on, attrs }">
        <mrc_ess_input
          v-bind="attrs"
          :label="label"
          :placeholder="label"
          :background-color="readonly ? '' : '#f5f5f5'"
          readonly
          :error-messages="errorMessages"
          :value="INT(showValue)"
          v-on="on"
        >
          <template v-slot:label="{ item }">
            <span>{{ INT(item.itemKey) }}</span>
          </template>

          <template v-slot:append>
            <v-icon
              @click="clearValue"
              v-if="INT(showValue)"
              style="z-index: 50; position: relative"
            >
              clear
            </v-icon>
            <v-icon @click="clickAppend">
              {{ showMenu ? "arrow_drop_up" : "arrow_drop_down" }}
            </v-icon>
          </template>
        </mrc_ess_input>
      </template>
      <v-list>
        <v-treeview
          dense
          selected-color="primary"
          :items="doc_tree"
          color="#0f46c1"
          item-key="uuid"
        >
          <template v-slot:label="{ item }">
            <span style="cursor: pointer" @click="SelectItem(item)">
              {{ INT(item[itemKey]) }}
            </span>
          </template>
        </v-treeview>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { doc_tree } from "@/service/api/directory_management.js";
export default {
  components: {},
  props: {
    uuid: {},
    errorMessages: {},
    filters: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "文件",
    },
    itemValue: {
      type: String,
      default: "tricode",
    },
    itemKey: {
      type: String,
      default: "directory_name",
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showMenu: false,
      doc_tree: [],
      showValue: "",
    };
  },
  model: {
    prop: "uuid",
    event: "change",
  },
  computed: {
    // showValue () {
    //   return this.uuid
    // }
  },
  async created() {
    await this.getTree();
  },
  watch: {
    uuid(val) {
      if (String(val)) {
        this.findValue(this.doc_tree);
      }
    },
  },
  mounted() {},
  methods: {
    async getTree() {
      doc_tree().then((res) => {
        if (res.code == 200) {
          if (this.filters) {
            this.removeTreeListItem(res.data, this.filters);
            this.doc_tree = res.data;
          } else {
            this.doc_tree = res.data;
          }
        }
      });
    },
    SelectItem(item) {
      this.$emit("change", item[this.itemValue]);
    },
    findValue(arr) {
      arr.forEach((item) => {
        if (item[this.itemValue] == this.uuid) {
          this.showValue = item[this.itemKey];
        } else {
          if (Array.isArray(item.children) && item.children.length > 0) {
            this.findValue(item.children);
          }
        }
      });
    },
    clickAppend() {
      this.showMenu = true;
    },
    removeTreeListItem(treeList, id) {
      // 根据id属性从数组（树结构）中移除元素
      if (!treeList || !treeList.length) {
        return;
      }
      for (let i = 0; i < treeList.length; i++) {
        if (treeList[i].uuid === id) {
          treeList.splice(i, 1);
          break;
        }
        this.removeTreeListItem(treeList[i].children, id);
      }
    },
    clearValue() {
      this.showValue = "";
      this.$emit("change", "");
    },
  },
};
</script>

<style scoped>
.v-input--selection-controls {
  margin: 0;
  padding: 0;
}
/deep/ .v-select__slot {
  min-height: 40px;
}
/deep/ .v-select__selections {
  min-height: 40px;
  padding-left: 8px;
}
/deep/ .v-list-item {
  min-height: 40px !important;
  padding: 0;
}
/deep/ .v-list-item__content {
  min-height: 40px !important;
  /* max-height: 48px !important; */
  /* padding: 7px 0; */
}
.overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.bigBox /deep/.v-input .v-label {
  top: 2px !important;
  /* left: -5px !important; */
}
/deep/ .v-input__append-inner {
  margin-top: 8px;
  margin-right: 8px;
}
.v-application--is-ltr .v-text-field .v-input__prepend-inner {
  padding: 0 !important;
}
</style>
